import { axiosInstance } from '@admin-panel/providers';

type Answer = Promise<{ data?: any }>;

/** An early answer older than this is not used: the page reads again. */
export const EARLY_READ_MS = 20_000;

const early = new Map<string, { at: number; answer: Answer }>();

/**
 * Starts a page's first read while its page file still loads, so the two come over the network side by side, not one
 * after the other (round 40, Ravi: a reloaded Quick Pick on 2G waited for its file, then for its read). A read
 * already started for the URL within EARLY_READ_MS is not sent again.
 */
export const startEarlyRead = (url: string) => {
  const known = early.get(url);
  if (known && Date.now() - known.at < EARLY_READ_MS) return;
  const answer: Answer = axiosInstance.get(url);
  // Its failure is the page's to handle, when it takes it.
  answer.catch(() => undefined);
  early.set(url, { at: Date.now(), answer });
};

/**
 * The early read for `url`, once: the page's first load uses it in place of its own request. Undefined when none was
 * started or it is older than EARLY_READ_MS (the page then reads as it always did).
 */
export const takeEarlyRead = (url: string): Answer | undefined => {
  const known = early.get(url);
  early.delete(url);
  if (!known || Date.now() - known.at >= EARLY_READ_MS) return undefined;
  return known.answer;
};
